import { useEffect } from "react";

const upsertMeta = (attribute: "name" | "property", key: string, content: string) => {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

export function usePageMeta(title: string, description: string, keywords?: string) {
  useEffect(() => {
    document.title = title;
    upsertMeta("name", "description", description);
    if (keywords) {
      upsertMeta("name", "keywords", keywords);
    }
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
  }, [title, description, keywords]);
}